import { Bookmark } from "@/context/BookmarkContext";
import { db } from "@/firebase/clientApp";
import { doc, getDoc, setDoc } from "firebase/firestore";

/**
 * Service for syncing bookmarks across devices using a unique sync ID
 */
export const BookmarkSyncService = {
  /**
   * Generate a unique sync ID
   */
  generateSyncId: (): string => {
    // Generate a random 8-character alphanumeric ID
    return Math.random().toString(36).substring(2, 10);
  },

  /**
   * Save bookmarks to the database using a sync ID
   */
  saveBookmarks: async (syncId: string, bookmarks: Bookmark[]): Promise<boolean> => {
    try {
      const bookmarksRef = doc(db, "bookmarkCollections", syncId);
      await setDoc(bookmarksRef, { 
        bookmarks, 
        updatedAt: new Date().toISOString() 
      });
      return true;
    } catch (error) {
      console.error("Error saving bookmarks:", error);
      return false;
    }
  },

  /**
   * Load bookmarks from the database using a sync ID
   */
  loadBookmarks: async (syncId: string): Promise<Bookmark[] | null> => {
    try {
      const bookmarksRef = doc(db, "bookmarkCollections", syncId);
      const bookmarksDoc = await getDoc(bookmarksRef);
      
      if (bookmarksDoc.exists()) {
        const data = bookmarksDoc.data();
        return data.bookmarks;
      } else {
        return null; // Sync ID not found
      }
    } catch (error) {
      console.error("Error loading bookmarks:", error);
      return null;
    }
  },

  /**
   * Validate a sync ID format (8 characters alphanumeric)
   */
  validateSyncId: (syncId: string): boolean => {
    return /^[a-z0-9]{8}$/.test(syncId);
  }
};